<template>
	<div class="d-flex">
		<div v-if="post.visibilitable_type == 'group' && !routeIsGroup">
			<router-link :to="{name: 'Group', params: {id: post.visibilitable_id}}" style="color: unset">
				<div class="d-flex relative">
					<avatar class="cursor-pointer" :group="post.visibilitable"/>
					<avatar xs color="blue" style="right: -2px; bottom: -2px" :user="post.user" class="absolute"/>
				</div>
			</router-link>
		</div>
		<div v-else>
			<content-hover :user="post.user" avatar hover-class="bold" />
		</div>
		<div class="pl-3">
			<div v-if="post.visibilitable_type == 'group' && !routeIsGroup" class="align-items-center d-flex bold">
				<router-link :to="{name: 'Group', params: {id: post.visibilitable_id}}" class="grey--text text--darken-1"><span class="font-14">{{ post.visibilitable.name }}</span></router-link>
				<v-chip  x-small class="bold px-2 ml-2">{{ $vuetify.lang.t('$vuetify.views.wall.post.groupPost')}}</v-chip>
			</div>
			<div class="d-flex flex-wrap grey--text text--darken-1" :class="post.visibilitable_type == 'group' && !routeIsGroup ? 'font-12' : 'font-14'">
				<content-hover v-if="post.visibilitable_type != 'group'" :user="post.user" hover-class="bold" />
				<content-hover v-else :user="post.user" :hover-class="routeIsGroup ? 'bold' : null" />
				<div v-if="type == 'post'" class="ml-1">{{ $vuetify.lang.t('$vuetify.views.wall.post.userAddedPost')}}</div>
				<div v-if="type == 'poll'" class="ml-1">{{ $vuetify.lang.t('$vuetify.views.wall.poll.userAddedPoll')}}</div>
				<div v-if="type == 'problem'" class="ml-1">{{ $vuetify.lang.t('$vuetify.views.wall.problem.userAddedProblem')}}</div>
				<div v-if="type == 'kudos'" class="ml-1 d-flex">{{ $vuetify.lang.t('$vuetify.views.wall.kudos.userAddedKudos')}}
					<content-hover :user=" post.postable.for_user" hover-class="bold ml-1"/>
				</div>
				<div v-if="type == 'image'" class="ml-1">{{ $vuetify.lang.t('$vuetify.views.wall.photo.userAddedPhoto')}}</div>
				<div v-if="type == 'video'" class="ml-1">{{ $vuetify.lang.t('$vuetify.views.wall.video.userAddedVideo')}}</div>
			</div>
			<div class="font-12 grey--text d-flex flex-wrap align-items-center"
				v-bind:class="{ 'text--darken-2' : pinned }">

				<v-tooltip bottom content-class="font-12">
					<template v-slot:activator="{ on }">
						<span v-on="on">{{ $moment(post.created_at).fromNow() }}</span>
					</template>
					{{ $moment(post.created_at).format('LLL') }}
				</v-tooltip>

				<template v-if="!pinned">
					<template v-if="edited"><span class="mx-1">&bull;</span>{{ $vuetify.lang.t('$vuetify.views.wall.post.edited')}}</template> <span class="mx-1">&bull;</span>
					<v-icon v-if="!post.visibilitable_id" class="font-14" :class="{ 'text--darken-2' : pinned }">mdi-web</v-icon>
					<v-icon v-else  style="width: 14px" :class="{ 'text--darken-2' : pinned }">$groups</v-icon>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import Avatar from "@/components/Avatar";
import ContentHover from '@/components/items/ContentHover';
export default {
	name: "PostTopLeft",
	components: {
		ContentHover,
		Avatar
	},
	props: {
		routeIsGroup: {
			type: Boolean,
			required: false,
			default: false
		},
		type: {
			type: String,
			required: true
		},
		pinned: {
			type: Boolean,
			required: true
		},
		/*
		edited: {
			type: Boolean,
			required: true
		},
		*/
		post: {
			type: Object,
			required: true
		}
	},
	computed: {
		edited() {
			return this.post.created_at !== this.post.updated_at;
		}
	}
}
</script>

<style scoped>

</style>
